import script from "./SPHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SPHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SPHeader.vue?vue&type=style&index=0&id=626b38d9&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626b38d9"]])

export default __exports__